import styled from 'styled-components';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    padding: 0 24px;
    font-weight: 500;
    
    @media (max-width: 768px) {
      width: 100%;
    }
    
    .anticon {
      font-size: 16px;
    }
  }
`;




